module.exports = __webpack_public_path__ + "img/bouton_d’or.c6b91c71.jpg";